document.addEventListener('DOMContentLoaded', function() {
    // Menú móvil
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');

    if (mobileMenuButton && mobileMenu) {
        mobileMenuButton.addEventListener('click', function() {
            mobileMenu.classList.toggle('hidden');
        });
    }

    // Smooth scroll para anclas
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const hrefAttribute = this.getAttribute('href');
            if (hrefAttribute.length > 1 && document.querySelector(hrefAttribute)) {
                e.preventDefault();
                document.querySelector(hrefAttribute).scrollIntoView({
                    behavior: 'smooth'
                });
                if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
                    mobileMenu.classList.add('hidden');
                }
            }
        });
    });

    // Manejo del formulario del Hero (hero-contact-form)
    const heroContactForm = document.getElementById('hero-contact-form');
    if (heroContactForm) {
        heroContactForm.addEventListener('submit', function(event) {
            event.preventDefault(); // Prevenir el envío normal del formulario

            const submitButton = this.querySelector('button[type="submit"]');
            const originalButtonText = submitButton.innerHTML;
            submitButton.disabled = true;
            submitButton.innerHTML = 'Enviando... <span class="spinner"></span>'; // Puedes tener un spinner CSS

            // Recolectar datos del formulario
            const nombre = document.getElementById('hero-nombre').value.trim();
            const apellido = document.getElementById('hero-apellido').value.trim();
            const telefono = document.getElementById('hero-telefono').value.trim();
            const email = document.getElementById('hero-email').value.trim();
            const mensaje = document.getElementById('hero-mensaje').value.trim();

            const nombreCompleto = `${nombre} ${apellido}`.trim();

            // Validación básica en frontend (HTML5 'required' ya ayuda, pero una extra no daña)
            if (!nombreCompleto || !telefono || !email) {
                alert('Por favor, completa todos los campos obligatorios (Nombre, Apellidos, Teléfono, Email).');
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;
                return;
            }

            const data = {
                nombreCompleto: nombreCompleto,
                telefono: telefono,
                email: email,
                mensaje: mensaje || '' // Mensaje es opcional
            };

            // ¡IMPORTANTE! Ajusta la URL para que apunte a tu script PHP en el servidor.
            // Si procesar-formulario.php está en la misma carpeta que tu HTML/PHP que carga este JS:
            // const backendUrl = 'procesar-formulario.php';
            // Si está en una carpeta 'api' en la raíz de tu sitio:
            const backendUrl = 'procesar-formulario.php'; // O la ruta correcta

            fetch(backendUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            .then(response => {
                if (!response.ok) {
                    // Si el servidor responde con un error (ej. 4xx, 5xx)
                    return response.json().then(errData => {
                        // Intenta obtener un mensaje de error del JSON, si no, usa el statusText
                        throw new Error(errData.message || response.statusText || 'Error en la respuesta del servidor.');
                    });
                }
                return response.json(); // Espera una respuesta JSON del backend
            })
            .then(result => {
                // Muestra el mensaje de éxito REAL del servidor
                alert(result.message || '¡Gracias! Tu solicitud ha sido enviada. Nos pondremos en contacto contigo pronto.');
                heroContactForm.reset(); // Limpiar el formulario
            })
            .catch((error) => {
                console.error('Error en fetch:', error);
                alert('Hubo un error al enviar tu mensaje: ' + error.message + '. Por favor, intenta de nuevo.');
            })
            .finally(() => {
                // Restaurar el botón
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;
            });
        });
    }

    // Estilo básico para un spinner (opcional, si lo usas en el botón)
    if (!document.getElementById('spinner-styles')) { // Evitar añadir múltiples veces
        const style = document.createElement('style');
        style.id = 'spinner-styles';
        style.innerHTML = `
            .spinner {
                display: inline-block;
                width: 1em;
                height: 1em;
                border: 2px solid rgba(255,255,255,.3); /* Color del borde del spinner */
                border-radius: 50%;
                border-top-color: #fff; /* Color de la parte que gira */
                animation: spin 1s ease-infinite;
                vertical-align: middle;
                margin-left: 5px;
            }
            @keyframes spin {
                to { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);
    }
});